import { observer } from 'mobx-react';
import React, { FC, useCallback } from 'react';
import { crmRestrictionsStore } from '../../store';
import { SearchInput } from '~/view/components/Controls/Inputs';
import { InputType } from '~/view/components/Controls/InputComponent/types';
import './style.scss';
import { localeStore } from '~/mobx/localesStore';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { history } from '~/services/history';
import { SCREENS } from '~/constants/screens';

const CrmRestrictionsHeader: FC = observer((): JSX.Element => {
  const onSearch = useCallback((search: string | undefined) => {
    if (crmRestrictionsStore.filters.search && !search) {
      crmRestrictionsStore.resetSearch();
    } else {
      crmRestrictionsStore.changeFilters({ search });
    }
  }, []);

  const createItem = () => {
    history.push(SCREENS.CRM_RESTRICTIONS_CREATE());
  };

  return (
    <div className="d-flex flex-row justify-content-between pr-4">
      <div className="d-flex flex-row gap-10">
        <SearchInput
          value={crmRestrictionsStore.filters.search}
          onChangeValue={onSearch}
          loading={crmRestrictionsStore.loading}
          contentClassName="customers-profiles-header__search"
          type={InputType.NUMBER}
        />
      </div>
      <div className="d-flex align-items-center">
        <Button title={localeStore.t('crm_restrictions_create')} onClick={createItem} loading={crmRestrictionsStore.loading} />
      </div>
    </div>
  );
});

export default CrmRestrictionsHeader;
